import React from 'react'

import { List } from 'ui'
import { t } from 'translations'

const AllShiftsDeleted = ({ originalShifts }) => {
  if (originalShifts.length) return null

  return (
    <List.Item>
      <i className="far fa-empty-set mr-1"></i>
      {t('manager.contactLists.ALL_SHIFTS_DELETED')}
    </List.Item>
  )
}

export default AllShiftsDeleted
